export enum ProductUnitCodeType {
  EAN13 = "8ad5eb7b-f480-4bb7-8982-702ceadb7f6c",
  SupplierCode = "8f69c5c0-fb46-4c61-bd78-7b6b71ffe64a",
  InternalCode = "6b3a97ca-fb47-4673-a6eb-c57441e41917",
  WeighingGoods = 'e8ee054f-1564-49b1-ad18-ca7a7944d06e'
}

(ProductUnitCodeType as any).__typeName = 'ProductUnitCodeType';
